// extracted by mini-css-extract-plugin
export var background = "_2-0";
export var container = "_2-1";
export var contentItem = "_2-7";
export var extendedWarranty = "_2-5";
export var link = "_2-d";
export var modal = "_2-b";
export var modalCloseButton = "_2-9";
export var modalContent = "_2-3";
export var modalContentMain = "_2-6";
export var modalImageLogo = "_2-8";
export var modalLogo = "_2-a";
export var modalSideImage = "_2-4";
export var preview = "_2-c";
export var redoModal = "_2-2";